@if (currentProduct) {
  <div>
    <smallstack-product-prices [productId]="currentProduct.id" />
  </div>
}
